/**
 *
 * Asynchronously loads the component for AssetDashboard
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetDashboard = lazyLoad(
  () => import('./index'),
  module => module.AssetDashboard,
);
